// src/api/dummyApi.js
// export const fetchClaimData = async (query) => {
//     return {
//       claim: query,
//       verdict: "Highly False",
//       records: [
//         { meeting: "Treasury Amendment", chamber: "House of Rep.", date: "13 Dec 2020", link: "###" },
//         { meeting: "Cost of Living", chamber: "House of Rep.", date: "14 Dec 2020", link: "###" },
//         { meeting: "Treasury Amendment", chamber: "House of Rep.", date: "07 Dec 2020", link: "###" },
//       ],
//       positiveSpeech: 0,
//       positiveVotes: 0,
//     };
//   };

// Example of Real API here. Swap after it's finalised
export const fetchClaimData = async (query) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v2/ai_claim_check_v2?claim=${encodeURIComponent(
        query
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
